import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {

applicationNamePass : any;

  constructor() { }
}
